import type { CatalogEntry } from "@core/types";
import { inputStyle } from "./FormField";
import { resolveBilingualText as text } from "./bilingualText";

// GATE-01-A (agent-logs/runs/2026-09-11-spec-219-offers/evidence/
// human-resolution-gate-01-dup-and-format.json): el selector "Categoría ·
// todas" del filtro extra de la barra de herramientas era el mismo marcado
// palabra por palabra en rewards/RewardsScreen.tsx y offers/OffersScreen.tsx
// — cada pantalla sigue eligiendo su propia fuente de catálogo
// (`reward-categories` / `offer-categories`) y pasa la lista ya resuelta.
// Extracción sin cambio de comportamiento ni de valores visuales: ninguna
// pantalla que la use cambia un pixel por esto.
export function CategoryFilterSelect({
  value,
  onChange,
  categories,
}: {
  value: string;
  onChange: (categoryId: string) => void;
  categories: CatalogEntry[] | undefined;
}) {
  return (
    <select
      value={value}
      onChange={(event) => onChange(event.target.value)}
      style={{
        ...inputStyle,
        width: "auto",
        minWidth: 168,
        cursor: "pointer",
      }}
    >
      <option value="">Categoría · todas</option>
      {categories?.map((category) => (
        <option key={category.id} value={category.id}>
          {text(category.name, "es")}
        </option>
      ))}
    </select>
  );
}
